var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 921,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1440 921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0a1620;\n      }\n\n      .cls-2 {\n        fill: url(#Nepojmenovan\xFD_p\u0159echod_5);\n      }\n\n      .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3, .cls-5 {\n        stroke: rgba(255, 255, 255, .06);\n      }\n\n      .cls-3, .cls-5, .cls-6 {\n        stroke-width: 1.37px;\n      }\n\n      .cls-5 {\n        fill: rgba(255, 255, 255, .05);\n      }\n\n      .cls-6 {\n        fill: url(#Nepojmenovan\xFD_p\u0159echod_4);\n        stroke: #0a151f;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 1440,
    height: 921
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Nepojmenovan\\xFD_p\\u0159echod_5",
    "data-name": "Nepojmenovan\\xFD p\\u0159echod 5",
    cx: 437.51,
    cy: 880.8,
    fx: 437.51,
    fy: 880.8,
    r: 1,
    gradientTransform: "translate(-765094.06 -299703.94) rotate(90) scale(684.37 -869.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#131f2b",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#131f2b",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#131f2b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Nepojmenovan\\xFD_p\\u0159echod_4",
    "data-name": "Nepojmenovan\\xFD p\\u0159echod 4",
    cx: 437.51,
    cy: 880.86,
    fx: 437.51,
    fy: 880.86,
    r: 1,
    gradientTransform: "translate(-870319.04 -271221.25) rotate(90) scale(620.61 -988.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a151f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0a151f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1440,
    height: 921
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 137.14,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 617.14,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 68.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1097.14,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 137.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 205.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 205.71,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 822.86,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 274.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1234.29,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 342.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 411.43,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 548.57,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 480,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 274.29,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 548.57,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 617.14,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 685.71,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 754.29,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.57,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.14,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.71,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.29,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.86,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 411.43,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 480,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 548.57,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.14,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 685.71,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 754.29,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.86,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 891.43,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 960,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1028.57,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1097.14,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1165.71,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1234.29,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1302.86,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1371.43,
    y: 822.86,
    width: 68.57,
    height: 68.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -116.57,
    y: -966.34,
    width: 1738.97,
    height: 1368.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: -309.26,
    y: -320.91,
    width: 1978.97,
    height: 1242.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.faaaff9030b958229c52f584c27583b2.svg";
export { ForwardRef as ReactComponent };